package com.neurobs.ccabserver.translationadmin.states

import com.neurobs.ccab.translation.TranslatorDataView
import com.neurobs.js.ccab.TranslationServer
import com.neurobs.js.util.ServerResponseUtil
import com.neurobs.react.{GenericState, GenericStateGenerator, ServerDataAttribute, StateAttribute}
import org.scalajs.dom.console
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.ReactElement

case class TranslationProgressState (
  translatorsState: ServerDataAttribute[List[TranslatorDataView]],
  selectedTranslatorsState: StateAttribute[List[TranslatorDataView]]
) extends GenericState {

  def selectTranslator(translatorDataView: TranslatorDataView) = {
    if (!selectedTranslatorsState.value.find(_.id == translatorDataView.id).isDefined) {
      selectedTranslatorsState.setValue(selectedTranslatorsState.value :+ translatorDataView)
    }
  }

  def clearTranslator(translatorDataView: TranslatorDataView) = {
    if (selectedTranslatorsState.value.find(_.id == translatorDataView.id).isDefined) {
      selectedTranslatorsState.setValue(selectedTranslatorsState.value.filterNot(_.id == translatorDataView.id))
    }
  }

  def loadAllTranslators() = {
    TranslationServer.getAllTranslators(handleServerTranslators)
  }

  def handleServerTranslators = {
    ServerResponseUtil.handleObjectResultResponse[Seq[TranslatorDataView]](
      handleObject = data => translatorsState.setData(data.toList),
      onAnyError = translatorsState.setError(_)
    )
  }
}

object TranslationProgressStateGenerator extends GenericStateGenerator[TranslationProgressState] {
  override def generateEmptyDefaultState(): TranslationProgressState = TranslationProgressState(
    translatorsState = emptyServerDataState[List[TranslatorDataView]](),
    selectedTranslatorsState = emptyDefaultState[List[TranslatorDataView]](List())
  )
}

@react
object TranslationProgressStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val translatorsState = ServerDataAttribute(useState[Either[Option[String], List[TranslatorDataView]]](Left(None)))
    val selectedTranslatorsState = StateAttribute(useState[List[TranslatorDataView]](List()))
    val translationProgressState = TranslationProgressState(
      translatorsState = translatorsState,
      selectedTranslatorsState = selectedTranslatorsState
    )

    useEffect(() => {
      translationProgressState.loadAllTranslators()
    }, Vector())

    TranslationProgressStateGenerator.Provider(translationProgressState)(
      props.children:_*
    )
  }
}